import React, { useState } from "react";
import { TextField, MenuItem, Box, Typography } from "@mui/material";
import dayjs from "dayjs";

const months = Array.from({ length: 12 }, (_, i) => ({
  value: i + 1,
  label: dayjs().month(i).format("MMMM"),
}));

const days = Array.from({ length: 31 }, (_, i) => ({
  value: i + 1,
  label: i + 1,
}));

const CustomDateInput = ({ onDateChange }) => {
  const currentYear = dayjs().year(); // Auto-fill current year
  const [date, setDate] = useState({ month: "", day: "", year: currentYear });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newDate = { ...date, [name]: value };

    // Ensure valid month/day before formatting
    if (newDate.month && newDate.day) {
      const formattedDate = `${newDate.year}-${String(newDate.month).padStart(
        2,
        "0"
      )}-${String(newDate.day).padStart(2, "0")}`;
      onDateChange(formattedDate);
    }

    setDate(newDate);
  };

  return (
    <Box display="flex" gap={2} alignItems="center">
      <Typography variant="body1">Select Date:</Typography>

      {/* Month Dropdown */}
      <TextField
        select
        label="Month"
        name="month"
        value={date.month}
        onChange={handleChange}
        variant="outlined"
        size="small"
      >
        {months.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      {/* Day Dropdown */}
      <TextField
        select
        label="Day"
        name="day"
        value={date.day}
        onChange={handleChange}
        variant="outlined"
        size="small"
      >
        {days.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      {/* Year (Auto-filled) */}
      <TextField
        label="Year"
        name="year"
        value={date.year}
        variant="outlined"
        size="small"
        disabled // Year is fixed to the current year
      />
    </Box>
  );
};

export default CustomDateInput;
